import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api/client';
import { useSession } from '@/lib/auth/session';
import { safeMenuKey } from '@/lib/loungeCompat';
import { isAdministrator } from '@/lib/types';

/**
 * 안전 홈페이지의 문(DOC-136 §6 · 백엔드 SafeAccess). 안전 권한이면 전 현장 · 대시보드, 없으면 배정 현장만.
 * 화면은 메뉴 · 바로가기를 고르는 데만 쓴다 — 판정은 서버가 요청마다 다시 한다.
 */
export type SafeAccessInfo = { all: boolean; siteIds: string[] };

export function useSafeAccess() {
  const session = useSession();
  const me = session.data?.authenticated ? session.data : null;
  const remote = useQuery({
    queryKey: ['safe-access', me?.user?.id ?? null],
    queryFn: () => apiFetch<SafeAccessInfo>('/v1/safe/access'),
    enabled: me !== null,
    staleTime: 60_000,
  });
  // 재시작 전 서버(엔드포인트 없음)도 세션의 메뉴 키로 「전 현장」 만은 판정한다.
  const all = me !== null && (isAdministrator(me.user?.userType) || me.visibleMenuKeys.includes(safeMenuKey()) || remote.data?.all === true);
  return { all, siteIds: remote.data?.siteIds ?? [], ready: me === null || !remote.isPending };
}
